import React from 'react';
import { ModeCharges } from '../CourierModeCharges/CourierModeCharges';

export const LandModeCharges = () => <ModeCharges mode="land" />;

export default LandModeCharges;
